import type * as PdfJsDist from 'pdfjs-dist';
import type { PDFDocumentProxy, RenderTask } from 'pdfjs-dist';

export type { PDFDocumentProxy, RenderTask };

type PdfJsModule = typeof PdfJsDist;

let pdfjsModule: PdfJsModule | null = null;

/**
 * Load PDF.js only in the browser (SSR has no window/worker/canvas).
 */
export async function loadPdfJs(): Promise<PdfJsModule> {
    if (typeof window === 'undefined') {
        throw new Error('PDF.js is only available in the browser');
    }

    if (!pdfjsModule) {
        const [pdfjs, worker] = await Promise.all([
            import('pdfjs-dist'),
            import('pdfjs-dist/build/pdf.worker.min.mjs?url'),
        ]);

        pdfjs.GlobalWorkerOptions.workerSrc = worker.default;
        pdfjsModule = pdfjs;
    }

    return pdfjsModule;
}
